import React from 'react';
import './components.css';

function Footer() {
    return (
        <section className='tile tile-links'>
            <h2 className='tile-label'>Find me 💌</h2>
            <ul className='link-list'>
                <li><a href="https://www.linkedin.com/in/sunwoo-ha/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                <li><a href="https://github.com/sunwooha" target="_blank" rel="noopener noreferrer">GitHub</a></li>
                <li><a href="https://scholar.google.com/citations?user=J7HAEDgAAAAJ&hl" target="_blank" rel="noopener noreferrer">Scholar</a></li>
                <li><a href="mailto:hasunwoo96@gmail.com">Email</a></li>
            </ul>
        </section>
    )
}

export default Footer;
